import { createStore, withProps } from '@ngneat/elf';
import { SelectOption } from '../../components/form-builder/form-builder.types';
import { DelaisReglementaires, DelaisReglementairesDto } from '@/types';

export interface DelaisReglementairesStateProps {
  response?: Partial<DelaisReglementaires>;
  dto?: Partial<DelaisReglementairesDto>;
  typeMarcherSelected?: SelectOption;
  modePassationSelected?: SelectOption;
}

export const delaisReglementairesFactory = (): DelaisReglementaires => ({
  id: {
    typeMarcher: { id: 0, description: '', code: '' },
    modePassation: { id: 0, libelle: '', restraint: false, type: null, etapes: null },
  },
  delaiPublicationLancement: 0,
  delaiLancementAttribution: 0,
  delaiAttributionDemarrage: 0,
});

export const delaisReglementairesInitialState: DelaisReglementairesStateProps = {
  response: structuredClone(delaisReglementairesFactory()),
  dto: {
    typeMarcherId: undefined,
    modePassationId: undefined,
    delaiPublicationLancement: undefined,
    delaiLancementAttribution: undefined,
    delaiAttributionDemarrage: undefined,
  },
  typeMarcherSelected: { name: '', code: undefined },
  modePassationSelected: { name: '', code: undefined },
};

export const delaisReglementairesStateStore = createStore(
  { name: 'delaisReglementaires-state' },
  withProps<DelaisReglementairesStateProps>({ ...delaisReglementairesInitialState })
);
